import styled from 'styled-components';

export const CellTitleDefaultBox = styled.span`
    color: ${props => props.theme.colors.textLight};
    ${({theme}) => theme.font.presets.body};
`;